/**
 * RmEditor继承修改基本信息 标题图  by xcc
 */
import React from 'react';
import EditorInformation from "../components/EditorInformation";
import {Icon, Radio, Row, Upload, Divider} from "antd";
import {getInfoFromLocalStorage} from "../../../actions";
import SimpleFloatTool from "../floatTool/simpleFloatTool";
import ChunkUpload from "../../../components/upload/ChunkUpload";
import {DetailDialog as Picture} from "../../resource/view/dialog/picture/picture";
import ImgChoose from "../components/editContentChoose/ImgChoose";
import VideoCapture from "../components/editContentChoose/VideoCapture";

export class EditorInformationOfRmEditor extends EditorInformation {

    renderEditorInformation = () => {
        const {informationStatus} = this.props;
        return (
            <div style={{display: informationStatus ? '' : 'none'}}>
                {/*副标题等*/}
                {this.renderFTitle()}
                {/*动态渲染的表单*/}
                <Row gutter={24}>{this.renderDynamicForm()}</Row>
                {/*标签*/}
                {this.renderLabel()}
                {/*站群扩展字段*/}
                <Row gutter={24}>{this.renderColumnExtendField()}</Row>
                {/*跳转链接*/}
                {this.renderMipLink()}
                {/*上传附件*/}
                {this.renderUpload()}
                {/*附件列表*/}
                {this.renderAttach()}
            </div>
        )
    };

    renderTitlePicFile = () => {
        return (
            <div className={'uploadModal'}>
                <SimpleFloatTool
                    style={{border: 'none'}}
                    visible={this.state.visibleValue}
                    top={140}
                    title={"标题图片"}
                    itemPaddingRight={0}
                    left={document.body.clientWidth < 1601 ? document.body.clientWidth - 220 : document.body.clientWidth - 220 - 405}
                    width={345}
                    onClose={() => {
                        this.setState({visibleValue: false})
                    }}
                    footer={null}
                    ref={simpleFloatTool => this.simpleFloatTool = simpleFloatTool}
                >
                    {this.renderTypeSelect()}
                    {this.renderTitlePicUpload()}
                </SimpleFloatTool>
                <style>
                    {`
                            .uploadModal tr:nth-child(2) td{
                                border:none !important;
                                padding:0px 0px 0px 15px !important;
                            }
                            .uploadModal tr:nth-child(3) td{
                                border:none !important;
                                padding:5px 20px 7px !important;
                            }
                    `}
                </style>
            </div>

        )
    };

    titlePicList = {
        "oneSmall": [{
            type: "oneSmall",
            width: 104,
            height: 104,
            marginLeft: 104,
            top: 37,
            titlePic: "",
            loading: false,
            fileList: [],
            hover: false
        }],
        "oneBig": [{
            type: "oneBig",
            width: 267,
            height: 146,
            marginLeft: 25,
            top: 37,
            imgWidth: 128,
            imgHeight: 128,
            titlePic: "",
            loading: false,
            fileList: [],
            hover: false
        }],
        "threeSmall": [{
            type: "threeSmall1",
            width: 104,
            height: 104,
            marginLeft: 104,
            top: 37,
            titlePic: "",
            loading: false,
            fileList: [],
            hover: false
        }, {
            type: "threeSmall2",
            width: 104,
            height: 104,
            marginLeft: 104,
            top: 229,
            titlePic: "", loading: false, fileList: [], hover: false
        }, {
            type: "threeSmall3",
            width: 104,
            height: 104,
            marginLeft: 104,
            top: 421,
            titlePic: "",
            loading: false,
            fileList: [],
            hover: false
        }],
    }

    currentUploadType = "";

    renderTitlePicUpload() {
        let {imgAll, videoAll} = this.state;
        let Token = getInfoFromLocalStorage('Token');
        let showPicList = this.titlePicList[this.titlePicShowType] || [];
        return (
            <div className={"titlePicUpload"}>
                {showPicList.length > 0 && showPicList.map((item, index) => {

                    const uploadButton = (
                        <div>
                            <Icon type={item.loading ? 'loading' : 'plus'}/>
                            <div className="ant-upload-text">上传图片</div>
                        </div>
                    );
                    return (
                        <div key={index}>
                            <Upload
                                name="avatar"
                                accept={"." + this.state.newPicType.join(",.")}
                                listType="picture-card"
                                className="avatar-uploader"
                                style={{textAlign: 'center', position: 'relative'}}
                                headers={{Authorization: 'Bearer ' + Token}}
                                showUploadList={false}
                                action="/storage/uploadFile"
                                fileList={item.fileList}
                                onPreview={this.handlePreview}
                                // onChange={this.handleChange}
                                customRequest={new ChunkUpload({
                                    checkFileURL: "/storage/checkFile",
                                    checkChunkURL: "/storage/checkChunk",
                                    uploadChunkURL: "/storage/uploadChunk",
                                    chunkUploadOverURL: "/storage/chunkIsUploadOver",
                                    mergeChunksURL: "/storage/mergeChunk"
                                }).start}
                                beforeUpload={this.beforeUploadTitle}
                                onChange={(info) => {
                                    this.currentUploadType = item.type;

                                    let currentShowTitlePic = this.titlePicList[this.titlePicShowType].find(item1 => item1.type === item.type);
                                    if (info.file.status === 'uploading') {
                                        currentShowTitlePic.loading = true;
                                        this.setState({});
                                    } else if (info.file.status === 'done') {
                                        currentShowTitlePic.loading = false;
                                        this.setState({});
                                    } else {
                                        this.setState({});
                                    }
                                    this.onChangeTitle(info)
                                }}
                                showPercent={false}
                            >
                                {item.titlePic ?
                                    <img src={item.titlePic} alt="avatar"
                                         style={{
                                             width: item.imgWidth ? `${item.imgWidth}px` : '85px',
                                             height: item.imgHeight ? `${item.imgHeight}px` : '85px',
                                             objectFit: 'cover'
                                         }}
                                         className={'uploadHover'}
                                         onMouseEnter={() => this.handleEnter(item)}
                                    /> : uploadButton}
                            </Upload>
                            <div style={{color: window.themeBgColor, display: 'flex', justifyContent: 'space-around'}}>
                                <span style={{cursor: 'pointer'}} onClick={() => {
                                    this.currentUploadType = item.type;
                                    this.imgChoose.showModal();
                                    this.contentChoose();
                                }}>正文选择</span>
                                <span style={{cursor: 'pointer'}} onClick={() => {
                                    this.currentUploadType = item.type;
                                    this.videoCaptureContent()
                                }}>视频截取</span>
                            </div>
                            {/*悬浮按钮*/}
                            {item.hover ? this.renderBtn(item) : null}
                            {/*预览*/}
                            <Picture ref={ref => this.detailDialog = ref} path={this.previewPic}/>
                            {/*正文选择*/}
                            <ImgChoose getImgChoose={(data) => this.getImgChoose(data)} imgAll={imgAll}
                                       ref={e => this.imgChoose = e}/>
                            {/*视频截取*/}
                            <VideoCapture getVideoPicture={(data) => this.getVideoPicture(data)} videoAll={videoAll}
                                          ref={e => this.videoCapture = e}/>
                            <Divider
                                style={{display: (item.type === "threeSmall1" || item.type === "threeSmall2" || item.type === "threeSmall3") ? "block" : "none"}}
                                dashed/>
                            <style>{`
                                    .titlePicUpload .ant-upload.ant-upload-select-picture-card{
                                        margin-left: ${item.marginLeft}px;
                                        width: ${item.width}px;
                                        height: ${item.height}px;
                                    }
                            `}</style>
                        </div>
                    )
                })}
            </div>
        )
    }

    // 传标题图
    getImgChoose = (data) => {
        if (data) {
            let currentShowTitlePic = this.titlePicList[this.titlePicShowType].find(item => item.type === this.currentUploadType);
            currentShowTitlePic.titlePic = data;
            this.setState({
                contentVisible: false
            })
        }
    };

    //传视频帧
    getVideoPicture = (data) => {
        if (data) {
            let currentShowTitlePic = this.titlePicList[this.titlePicShowType].find(item => item.type === this.currentUploadType);
            currentShowTitlePic.titlePic = data;
            this.setState({})
        }
    };

    // 标题图上传
    onChangeTitle = (info) => {
        info.fileList = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if (info.file.response && info.file.response.data) {
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                item.url = info.file.response && info.file.response.path;
                item.name = info.file.response && info.file.response.name;
                item.type = "picture";
                item.isChunk = true;
                item.status = info.file.status;
            }
            return item;
        });
        let fileList = [info.fileList.at(-1)];
        let showPicList = this.titlePicList[this.titlePicShowType];
        let currentShowTitlePic = showPicList.find(item => item.type === this.currentUploadType);
        currentShowTitlePic.titlePic = fileList[0].url;
        currentShowTitlePic.fileList = fileList;
        // this.state.information.titlePic = showPicList[0].titlePic;
        this.setState((prevState) => {
            return ({
                ...prevState?.information,
                titlePic: showPicList[0].titlePic
            })
        });
        // if (info.file.status === 'uploading') {
        //     currentShowTitlePic.loading = true;
        //     this.setState({});
        // } else if (info.file.status === 'done') {
        //     currentShowTitlePic.loading = false;
        //     this.setState({});
        // } else {
        //     this.setState({});
        // }
    };

    titlePicShowType = "oneSmall";

    renderTypeSelect() {
        return (
            <div style={{display: "flex", alignItems: "center"}}>
                <div>显示类型：</div>
                <Radio.Group style={{lineHeight: "37px"}}
                             value={this.titlePicShowType}
                             onChange={(e) => {
                                 this.titlePicShowType = e.target.value;
                                 this.setState({});
                                 if(this.titlePicList) this.revertPic();
                             }}>
                    <Radio style={{marginRight: 5}} key={"small"} value={"oneSmall"}>一小图</Radio>
                    <Radio style={{marginRight: 5}} key={"big"} value={"oneBig"}>一大图</Radio>
                    <Radio key={"three_small"} value={"threeSmall"}>三小图</Radio>
                </Radio.Group>
            </div>
        )
    }

    revertPic() {
        let showPicList = this.titlePicList[this.titlePicShowType];
        showPicList.forEach(item => {
            item.fileList = [];
            item.titlePic = "";
        })
        this.state.information.titlePic = "";
        this.setState({});
    }

    //鼠标移出
    handleOut = (item) => {
        item.hover = false;
        this.setState({})
    };

    // 删除按钮
    handleDelete = (item) => {
        item.hover = false;
        item.titlePic = "";
        this.state.information.titlePic = "";
        this.setState({
            item: {...item}
        })
    };

    //鼠标移入
    handleEnter = (item) => {
        item.hover = true;
        this.setState({})
    };

    // 编辑
    handleEdit = (item, name) => {
        let that = this;
        window.edit.callback = function (obj) {
            item.titlePic = obj.path;
            that.setState({
                item: {...item}
            })
        };
        window.edit.openEditPictureFrame(item.titlePic, name);
    };

    previewPic = "";

    //鼠标悬浮图片按钮
    renderBtn = (item) => {
        return (
            <div style={{
                display: 'block'
            }} onMouseLeave={() => this.handleOut(item)}>
                <div style={{
                    width: item.width,
                    height: item.height,
                    background: 'rgba(0,0,0,0.4)',
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    position: 'absolute',
                    top: item.top,
                    left: item.marginLeft,
                    padding: '0 10px'
                }}>
                    <Icon type={'eye'} style={{width: 20, height: 20, color: "#fff", cursor: 'pointer'}}
                          onClick={() => {
                              this.previewPic = item.titlePic;
                              this.setState({})
                              this.handlePreview();
                          }}
                    />
                    <Icon type={'delete'} style={{width: 20, height: 20, color: "#fff", cursor: 'pointer'}}
                          onClick={() => this.handleDelete(item)}
                    />
                    <Icon type={'edit'} style={{width: 20, height: 20, color: "#fff", cursor: 'pointer'}}
                          onClick={() => {
                              let imgName = "";
                              this.handleEdit(item, imgName)
                          }}
                    />
                </div>
            </div>
        )
    };
}